module.exports = __webpack_public_path__ + "biologic-white-text.png";